import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/stores/auth';

export function UserMenu() {
  const user = useAuth((s) => s.user);
  const logout = useAuth((s) => s.logout);
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--space-3)' }}>
      <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-secondary)' }}>
        {user.email} · {user.role.replace('_', ' ').toLowerCase()}
      </span>
      <button
        type="button"
        style={{ padding: '4px 10px', fontSize: 'var(--text-xs)' }}
        onClick={async () => {
          await logout();
          navigate('/login');
        }}
      >
        Sign out
      </button>
    </span>
  );
}
